/**
 *
 * NotificationEngine
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';

import injectReducer from 'utils/injectReducer';

import Notification from 'components/Notification';

import makeSelectNotificationEngine from './selectors';
import reducer from './reducer';
import { dismissNotification } from './actions';
import useNotificationAutoDismiss from './utils';

function NotificationEngine({ dispatch, dismiss, active }) {
  useNotificationAutoDismiss();

  const notifs = active.map((n, idx) => (
    <Notification
      key={`${n.id}--${idx}`} // eslint-disable-line react/no-array-index-key
      dispatcher={dispatch}
      dismiss={dismiss}
      {...n}
    />
  ));

  return <div>{notifs}</div>;
}

NotificationEngine.propTypes = {
  dispatch: PropTypes.func.isRequired,
  dismiss: PropTypes.func.isRequired,
  active: PropTypes.array.isRequired,
};

const mapStateToProps = makeSelectNotificationEngine();

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    dismiss: (id) => dispatch(dismissNotification(id)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

const withReducer = injectReducer({ key: 'notificationEngine', reducer });

export default compose(
  withReducer,
  withConnect,
)(NotificationEngine);
